import AdmissionPolicy from '../policies/Admissions Policy.pdf'
import DataProtection from '../policies/2 Data Protection and Access to Records Policy.pdf'
import FirstAidPolicy from '../policies/4 First Aid Policy.pdf'
import HealthAndSafety from '../policies/5 Health and Safety Policy.pdf'
import ESafety from '../policies/7 E-Safety Policy.pdf'
import WhistleBlowing from '../policies/6 Whistle Blowing Policy ORTU.pdf'
import EQuality from '../policies/9 Equality and Diversity Policy.pdf'
import Placement from '../policies/10 Placement Planning Policy.pdf'
import Independent from '../policies/13 Indepedent saeguarding policy.pdf'
import SafeGuarding from '../policies/14 safeguarding adults policy.pdf'
import Accident from '../policies/21 First Aid and Accident Reporting Procedures.pdf'
import Behaviour from '../policies/45 Behaviour management Policy.pdf'
import missing from '../policies/72 Missing from care  Policy.pdf'
import SelfHarm from '../policies/73 self harm.pdf'
import OrtuHome from '../policies/Ortu Home and home child safeguarding policy.pdf'
import Statement from '../policies/Statement of purpose.pdf'
import Aims from '../policies/Aims and Objectives Elmfield  AVENUE .doc'

export const polfiles = [
    {id: 1,
     title: " Admission Policy",
     file: AdmissionPolicy
    },

    {id: 2,
     title: " Data Protection and Access to Records Policy",
     file: DataProtection
    },

    {id: 3,
        title: " First Aid Policy",
        file: FirstAidPolicy
       },

    {id: 4,
        title: " Health and Safety Policy",
        file: HealthAndSafety
    },

    {id: 5,
        title: " E-Safety Policy",
        file: ESafety
    },

    {id: 6,
        title: " Ortu Home and home child safeguarding policy",
        file: OrtuHome
    },

    {id: 7,
        title: " Self Harm policy",
        file: SelfHarm
    },

    {id: 8,
        title: " Missing from care policy",
        file: missing
    },

    {id: 9,
        title: " Behaviour management Policy",
        file: Behaviour
    },

    {id: 10,
        title: " First Aid and Accident Reporting Procedures",
        file: Accident
    },

    {id: 11,
        title: " Safeguarding adults policy",
        file: SafeGuarding
    },

    {id: 12,
        title: " Indepedent saeguarding policy",
        file: Independent
    },

    {id: 13,
        title: " Placement Planning Policy",
        file: Placement
    },

    {id: 14,
        title: " Equality and Diversity Policy",
        file: EQuality
    },

    {id: 15,
        title: " Whistle Blowing Policy ORTU",
        file: WhistleBlowing
    },

    {id: 16,
        title: " Statement of purpose",
        file: Statement
    },

    {id: 17,
        title: " Aims and Objectives - Elmfield House",
        file: Aims
    }


   
]